import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

import { reactive, ref, unref, onMounted } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { ModuleCreateApi, ModuleEditApi, ModuleDetailApi } from '@/apis/basics/modules/api';
import { ModuleBaseDto } from '../../../../apis/basics/modules/dto';



export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales();
const { getSelectList } = useDictionary();

const show = ref<boolean>(false);
const loading = ref<boolean>(false);
const isEditor = ref<boolean>(false);
const isRoot = ref<boolean>(false);

const dialogTitle = ref<string>(t('basics.modules.dialog.title.manage', '系统模块管理'));

const formRef = ref<ComponentRef<typeof ElForm>>();

const formSchema = ref<ModuleBaseDto>({
	id: '',
	revision: '0',
	pid: '',
	name: '',
	code: '',
	path: '',
	module_type: 0,
	module_app: 1,
	is_enabled: 'N',
	meta: '',
	remark: '',
	sort: 100,
	component_path: '',
});

const formRules = reactive<FormRules>({
	code: [{ required: true, message: t('basics.modules.dialog.form.code') + t('validation.required', '不能为空'), trigger: 'blur' }],
	name: [{ required: true, message: t('basics.modules.dialog.form.name') + t('validation.required', '不能为空'), trigger: 'blur' }],
	path: [{ required: true, message: t('basics.modules.dialog.form.path') + t('validation.required', '不能为空'), trigger: 'blur' }],
	component_path: [{ required: true, message: t('basics.modules.dialog.form.componentPath') + t('validation.required', '不能为空'), trigger: 'blur' }],
});

/* 打开对话框 */
const modify = async (rowId: string) => {
	loading.value = true;

	const { succeeded, errors, data } = await ModuleDetailApi(rowId);

	loading.value = false;

	if (!succeeded) {
		ElMessage.error(errors);
	} else {
		formSchema.value = data;
		show.value = true;
	}

	dialogTitle.value = t('basics.modules.dialog.title.edit', '编辑系统模块');
	isEditor.value = true;
};

/* 创建根目录*/
const createRoot = () => {
	unref(formSchema).pid = '10000000-0000-0000-0000-000000000001';
	unref(formSchema).module_type = 1;

	dialogTitle.value = t('basics.modules.dialog.title.createRoot', '创建根目录');
	isRoot.value = true;
	isEditor.value = false;
	show.value = true;
};

/* 创建子模块 */
const creaetChild = (parentId: string) => {
	formSchema.value = Object.assign({ pid: parentId, is_enabled: 'Y', revision: '0', sort: 100, id: '' });

	show.value = true;
	isRoot.value = false;
	isEditor.value = false;

	dialogTitle.value = t('basics.modules.dialog.title.createChild', '创建子模块');
};

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	const formData = unref(formSchema);

	const api = !unref(isEditor) ? ModuleCreateApi : ModuleEditApi;

	loading.value = true;

	api(formData)
		.then((res) => {
			const { succeeded, errors, data } = res;

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success(t('messages.saveSuccess', '保存成功'));
				show.value = false;
			}
		})
		.finally(() => {
			loading.value = false;
			$emits('refresh');
		});
};

onMounted(() => {});

expose({ modify, creaetChild, createRoot });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((show).value = $event)),
    title: dialogTitle.value,
    style: {"width":"850px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: loading.value,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        disabled: loading.value,
        onClick: _cache[10] || (_cache[10] = ($event: any) => (show.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
        ref_key: "formRef",
        ref: formRef,
        model: formSchema.value,
        "label-width": "140px",
        rules: _unref(formRules)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 15 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.code', '模块标识(唯一)'),
                    prop: "code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formSchema.value.code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.code) = $event)),
                        type: "text",
                        placeholder: _unref(t)('basics.modules.dialog.form.placeholder.code', '请输入模块标识')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.name', '模块名称'),
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formSchema.value.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.name) = $event)),
                        type: "text",
                        placeholder: _unref(t)('basics.modules.dialog.form.placeholder.name', '请输入模块名称')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.path', '页面Url'),
                    prop: "path"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formSchema.value.path,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.path) = $event)),
                        type: "text",
                        placeholder: _unref(t)('basics.modules.dialog.form.placeholder.path', '请输入页面Url')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.componentPath', '组件文件Url'),
                    prop: "component_path"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formSchema.value.component_path,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.component_path) = $event)),
                        type: "text",
                        placeholder: _unref(t)('basics.modules.dialog.form.placeholder.componentPath', '请输入组件文件Url')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.meta', 'Meta参数(JSON)'),
                    prop: "meta"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formSchema.value.meta,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.meta) = $event)),
                        type: "textarea",
                        rows: "4",
                        "show-word-limit": "",
                        maxlength: "500",
                        placeholder: _unref(t)('basics.modules.dialog.form.placeholder.meta', '请输入Meta参数')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.sort', '排序')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: formSchema.value.sort,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.sort) = $event)),
                        step: "100",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.type', '类型'),
                    prop: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: formSchema.value.module_type,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.module_type) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('module_type'), (mType) => {
                            return (_openBlock(), _createBlock(_component_el_radio_button, {
                              label: mType.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(mType.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 512), [
                [_vShow, !isRoot.value]
              ]),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.app', '设备类型'),
                    prop: "app"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: formSchema.value.module_app,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.module_app) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('module_app'), (mType) => {
                            return (_openBlock(), _createBlock(_component_el_radio_button, {
                              label: mType.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(mType.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.isEnabled', '启用模块'),
                    prop: "is_enabled"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: formSchema.value.is_enabled,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: "Y" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('basics.modules.status.enabled', '启用')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: "N" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('basics.modules.status.disabled', '停用')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('basics.modules.dialog.form.remark', '备注'),
                    prop: "remark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        "show-word-limit": "",
                        maxlength: "50",
                        modelValue: formSchema.value.remark,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.remark) = $event)),
                        rows: "4",
                        placeholder: _unref(t)('basics.modules.dialog.form.placeholder.remark', '备注')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})